import { MatTreeNestedDataSource } from '@angular/material/tree';
import { TreeService } from '../../../../../services/location/tree.service';
import { PolicyDataService } from '../../../../../services/shared/policy-data.service';
import { SaveService } from '../../../../../services/shared/save.service';
import { ActivatedRoute } from '@angular/router';
import { PolicyService } from '@modules/policy/policy.service';

import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormSaveHelper } from '@modules/policy/services/shared/save';

import LocationTabs from '@shared/models/location.model';
import { PolicyState } from '@shared/models/state.model';
import { CoverageTableComponent } from '@modules/policy/shared/components/coverage-table/coverage-table.component';
import { of } from 'rxjs';

@Component({
  selector: 'app-bins-and-silos-coverage-details',
  templateUrl: './bins-and-silos-coverage-details.component.html',
  styleUrls: ['./bins-and-silos-coverage-details.component.scss']
})
export class BinsAndSilosCoverageDetailsComponent implements OnInit {
  policyID: string;
  locationID: string;
  nodeID: string;
  dataSource: MatTreeNestedDataSource<LocationTabs>;
  subtab: string = "farmCoverageDetails";
  tab: string = "location";
  states: PolicyState;
  binsStates;
  form: FormGroup;
  @ViewChild("tableComponent", { static: false }) tableComponent: CoverageTableComponent;

  constructor(
    private route: ActivatedRoute,
    private PolicyDataService: PolicyDataService,
    private TreeService: TreeService,
    private PolicyService: PolicyService,
    private FormSaveHelper: FormSaveHelper,
    private SaveService: SaveService
  ) { }

  saveBeforeDeactivate() {
    if (this.PolicyService.getForm(Number(this.nodeID)) != null) {
      const cascadingIds: object = {
        nodeState: [Number(this.nodeID), this.form.valid],
        riskState: [this.binsStates["id"], this.TreeService.isRiskValid(this.binsStates["id"], this.locationID)],
        locationState: [Number(this.locationID), this.TreeService.isLocationValid(this.locationID)],
        tabState: [this.states["location"]["id"], this.form.parent ? this.form.parent.valid : false]
      };
      const cascadingStates = this.FormSaveHelper.buildStatePayload(cascadingIds);
      this.SaveService.updateStates(this.policyID, cascadingStates).subscribe();
      return this.tableComponent.saveBeforeDeactivate();
    }
    return of(null).toPromise();
  }

  showSaveSnackbar() {
    this.tableComponent.showSaveSnackbar();
    this.tableComponent.updateNavigationTree();
  }

  ngOnInit() {
    this.matTreeSubscription();
    this.policyID = this.PolicyDataService.getPolicyID();
    this.route.params.subscribe(params => {
      this.locationID = params["locationId"];
      this.nodeID = params["formId"];
      this.PolicyDataService.stateSubject.subscribe(states => {
        this.updateCurrentRiskStates(states);
        this.states = states;
      })
    })
  }

  initForm(form: FormGroup) {
    this.form = form;
  }

  updateNavigationTree() {
    this.PolicyDataService.getPolicyStates(this.policyID).subscribe(tree => {
      this.updateCurrentRiskStates(tree);
      this.states = tree;
      this.PolicyDataService.updateStates(tree);
    })
  }

  matTreeSubscription() {
    this.dataSource = new MatTreeNestedDataSource<LocationTabs>();
    this.TreeService.dataSourceSubject.subscribe(data => {
      this.dataSource.data = null;
      this.dataSource.data = data;
    });
  }

  updateCurrentRiskStates(states) {
    const tabState = states["location"];
    const currentLocation = tabState.locations.find(loc => loc.id == this.locationID);
    const currentBins = currentLocation.binsAndSilos.find(outbuilding => outbuilding.BinsAndSilosCoverageDetails.id == this.nodeID);
    this.binsStates = currentBins;
    
  }
}
